import { ActionTypeCreator } from 'app-webtech-core/actions/actionType';

const ActionType = new ActionTypeCreator('PLAYBACK_SESSION');

export const HEARTBEAT = ActionType.simple('HEARTBEAT');
export const LOADING = ActionType.simple('LOADING');
export const LOADED = ActionType.simple('LOADED');
export const LOADING_ERROR = ActionType.simple('LOADING_ERROR');
export const SESSION_RESET = ActionType.simple('SESSION_RESET');
export const SET_ID = ActionType.simple('SET_ID');
export const SET_SESSION_URL = ActionType.simple('SET_SESSION_URL');
export const TRACK_PLAYING_AD = ActionType.simple('TRACK_PLAYING_AD');
export const SET_MARKETING_REGION = ActionType.simple('SET_MARKETING_REGION');
export const TRACK_EVENTS = ActionType.simple('TRACK_EVENTS');
